<template>

<app-content-box :transparent="true" title="Your schedule" :not-padded="true" icon="dashboard.calendar">

    <div class="calendar" :data-size="size">

        <div class="calendar-day" v-for="(day, index) in $con.schedule.days" :key="index">

            <div class="calendar-day-date">{{ $constants.schedule.dayShort[index] }}</div>

            <div class="calendar-day-empty" v-if="!events[index].length">No events joined.</div>

            <div class="calendar-day-metrics" v-if="events[index].length">

                <div class="calendar-day-metrics-item" v-for="event in events[index]" :key="event.id" v-tooltip="'Click to view event'" v-on:click="onEventClick(event.id)">
                    <div class="calendar-day-metrics-item-time">{{ $constants.schedule.timeShort[event.time] }}</div>
                    <div class="calendar-day-metrics-item-text">{{ event.name }}</div>
                </div>

            </div>

            <div class="calendar-day-info">
                <div class="calendar-day-info-item" v-tooltip="'Click to browse events'" v-on:click="onTotalClick(index)"><span>{{ data.totals[index] || 0 }}</span>events scheduled</div>
            </div>

        </div>

    </div>

</app-content-box>

</template>

<script>

export default {

    props: ['data'],

    computed: {

        events: function() {

            var events = {}

            this.$_.each(this.$con.schedule.days, function(day, value) {
            
                events[value] = []
            
            })

            this.$_.each(this.data.joined, function(event) {
            
                events[event.day].push(event)

            })
        
            return events

        },
    
        size: function() {
        
            return this.$_.keys(this.$con.schedule.days).length
        
        }
    
    },

    methods: {

        onEventClick: function(id) {
        
            this.$router.push({
                name: 'Convention.Schedule.Event',
                params: {
                    id: id
                }
            })

        },
    
        onTotalClick: function(value) {
        
            this.$router.push({
                name: 'Convention.Schedule.Browse',
                query: {
                    day: value
                }
            })
        
        }
    
    }

}

</script>

<style scoped>

.calendar {
    display: grid;
    grid-template-columns: 1fr;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    overflow: hidden;
    min-height: 240px;
    height: 100%;
}

.is-mobile .calendar {
    margin-bottom: 15px;
}

.calendar-day {
    border-right: 1px solid #ddd;
    padding: 10px;
    background-color: #fff;
}

.calendar-day:nth-child(even) {
    background-color: #f7f7f7;
}

.calendar-day:last-child {
    border-right: 0px;
}

.calendar-day-date {
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
    text-transform: uppercase;
    color: #4082d3;
    font-family: "Red Hat Mono", monospace;
    margin-bottom: 8px;
}

.calendar-day-info {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    padding: 10px;
}

.is-mobile .calendar-day-info {
    position: relative;
    left: auto;
    bottom: auto;
    padding: 0px;
}

.calendar-day-info-item {
    font-size: 14px;
    line-height: 18px;
    user-select: none;
    padding: 10px;
    text-align: center;
    background-color: #4082d3;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
}

.is-small-desktop .calendar-day-info-item {
    font-size: 12px;
    padding: 10px 5px;
}

.calendar-day-info-item:hover {
	background-color: #236dc9;
}

.calendar-day-info-item span {
    color: #4082d3;
    background-color: #fff;
    font-weight: 500;
    border-radius: 4px;
    padding: 0px 6px;
    margin-right: 5px;
}

.calendar-day-empty {
    font-size: 20px;
    color: #ccc;
    line-height: 24px;
    text-align: center;
    left: 0px;
    width: 100%;
    padding: 0px 20px;
    position: absolute;
    top: 50%;
    margin-top: -10px;
    transform: translateY(-50%);
    font-weight: 500;
}

.is-mobile .calendar-day-empty {
    position: relative;
    margin-top: 0px;
    font-size: 16px;
    text-align: left;
    padding: 0px;
    padding-bottom: 10px;
    transform: none;
    top: auto;
    left: auto;
}

.calendar-day-metrics {
    position: absolute;
    left: 0px;
    top: 36px;
    right: 0px;
    bottom: 51px;
    overflow-y: auto;
}

.is-mobile .calendar-day-metrics {
    position: relative;
    left: auto;
    top: auto;
    margin-bottom: 10px;
    right: auto;
    bottom: auto;
}

.calendar-day-metrics-item {
    display: grid;
    grid-template-columns: 32px auto;
    cursor: pointer;
    grid-gap: 10px;
    padding: 2px 10px;
}

.is-mobile .calendar-day-metrics-item {
    padding: 2px 0px;
}

.calendar-day-metrics-item:hover {
    background-color: #eee;
}

.calendar-day-metrics-item-time {
    line-height: 18px;
    font-size: 14px;
    font-weight: 400;
}

.calendar-day-metrics-item-text {
    line-height: 18px;
    font-size: 14px;
}

.calendar[data-size="1"] {
    grid-template-columns: 1fr;
}

.calendar[data-size="2"] {
    grid-template-columns: 1fr 1fr;
}

.calendar[data-size="3"] {
    grid-template-columns: 1fr 1fr 1fr;
}

.calendar[data-size="4"] {
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.calendar[data-size="5"] {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.calendar[data-size="6"] {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}

.calendar[data-size="7"] {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}

.is-mobile .calendar[data-size="1"],
.is-mobile .calendar[data-size="2"],
.is-mobile .calendar[data-size="3"],
.is-mobile .calendar[data-size="4"],
.is-mobile .calendar[data-size="5"],
.is-mobile .calendar[data-size="6"],
.is-mobile .calendar[data-size="7"] {
    grid-template-columns: 1fr;
}

</style>